import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/UnSubModal.scss';
import { HashLink } from 'react-router-hash-link';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';

export const confirmModalButton = 'sms-confirm-modal-button';

export function ConsentConfirmationModal({
  confirm,
  cancel,
  isPromotionsConsent,
  isProConsent,
}) {

  const promotionsText = () => {
    return (
      <>
        {`By providing your phone number and clicking "Confirm," you consent to
        The Home Depot contacting you at `}<b>65624</b>{` for The Home Depot promotional messages,
        including those sent using automated technology, SMS/MMS, and/or prerecorded, AI, or
        artificial messages. Consent is not required to make a purchase. Messaging frequency
        varies. Message and data rates may apply. Not all carriers are supported. For help, text
        HELP or call 1-800-466-3337; to stop, text STOP or call 1-800-553-3199. I understand that
        confirming this message constitutes as my signature. I further understand that my
        information will be used as described here and in The Home Depot's `}
        <HashLink to="/privacy/privacy-and-security-statement">
          <u>Privacy and Security Statement</u>
        </HashLink>.
      </>
    );
  };

  const proConsentText = () => {
    return (
      <>
        {`By providing your phone number and clicking "Confirm," you consent to
        The Home Depot contacting you at `}<b>38688</b>{` for Pro marketing messages, including those
        sent using automated technology, SMS/MMS, and/or prerecorded, AI, or artificial messages.
        Consent is not required to make a purchase. Messaging frequency varies. Message and data
        rates may apply. Not all carriers are supported. For help, text HELP or call
        1-800-466-3337; to stop, text STOP or call 1-800-553-3199. I understand that confirming
        this message constitutes as my signature. I further understand that my information will be
        used as described here and in The Home Depot's `}
        <HashLink to="/privacy/privacy-and-security-statement">
          <u>Privacy and Security Statement</u>
        </HashLink>.
      </>
    );
  };

  const proAndPromotionsConsentText = () => {
    return (
      <>
        {`By providing your phone number and clicking "Confirm," you consent to
        The Home Depot contacting you at `}<b>65624</b>{' or '}<b>38688</b>
        {` for The Home Depot promotional or Pro marketing messages, including those sent using
        automated technology, SMS/MMS, and/or prerecorded, AI, or artificial messages. Consent is
        not required to make a purchase. Messaging frequency varies. Message and data rates may
        apply. Not all carriers are supported. For help, text HELP or call 1-800-466-3337;
        to stop, text STOP or call 1-800-553-3199. I understand that confirming this message
        constitutes as my signature. I further understand that my information will be used as
        described here and in The Home Depot's `}
        <HashLink to="/privacy/privacy-and-security-statement">
          <u>Privacy and Security Statement</u>
        </HashLink>.
      </>
    );
  };

  return (
    <Modal open onClose={cancel}>
      <ModalHeader onClose={cancel}>Confirm Your Consent</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          {isPromotionsConsent && !isProConsent && promotionsText()}
          {isProConsent && !isPromotionsConsent && proConsentText()}
          {isProConsent && isPromotionsConsent && proAndPromotionsConsentText()}
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <Button aria-label={confirmModalButton} onClick={confirm}>
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );

}

const propTypes = {
  confirm: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  isPromotionsConsent: PropTypes.bool.isRequired,
  isProConsent: PropTypes.bool.isRequired,
};

ConsentConfirmationModal.propTypes = propTypes;
